import Preloader from "@/components/landing/preloader/Preloader";
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

function ScrollToTopOnNavigate() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function RootLayout() {
  return (
    <>
      <Preloader />
      <ScrollToTopOnNavigate />
      <Outlet />
    </>
  );
}
